import NewQuestionSetForm from './NewQuestionSetForm'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'
import { useParams } from 'react-router-dom'
import { useGetQuestionSetsQuery } from './questionSetsApiSlice'
import { useGetCoursesQuery } from "../courses/coursesApiSlice"

const NewQuestionSet = () => {
    useTitle('geshtop-Exercise: New QuestionSets')

    const { questionSetId } = useParams()

    const { questionSet } = useGetQuestionSetsQuery("questionSetsList", {
        selectFromResult: ({ data }) => ({
            questionSet: data?.entities[questionSetId]
        }),
    })

    const { courses } = useGetCoursesQuery("coursesList", {
        selectFromResult: ({ data }) => ({
            courses: data?.ids.map(id => data?.entities[id])
        }),
    })
  
    if (!courses?.length) return <PulseLoader color={"#FFF"} />

    const content = <NewQuestionSetForm courses={courses} questionSet={questionSet} />

    return content
}
export default NewQuestionSet